import { IdRequest, UrlResponse } from '../request-response';
import { ResourceName } from '../resource-name';

export const StripeGate = {
  resource: ResourceName.stripe,
  actions: {
    getInvoiceList: 'get-invoice-list',
    getSubscription: 'get-subscription',
    getCustomerPotalUrl: 'get-customer-portal-url',
  },
};

export type StripeActionTypes = {
  getInvoiceList: {
    request: any;
    response: any;
  };
  getSubscription: {
    request: IdRequest;
    response: any;
  };
  getCustomerPotalUrl: {
    request: { customerId: string };
    response: UrlResponse;
  };
};
